
(function() {
  var result = { translations: { "ru": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0435\u0439", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u043C", "hours": "{{ hours }}\u0447", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0447 {{ minutes }}\u043C" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0431\u0430\u0432. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ru": "static-7.1162"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1162",
    "ar-eg": "static-7.1162",
    "bg": "static-7.1162",
    "bn": "static-7.1162",
    "ca-es": "static-7.1162",
    "cs": "static-7.1162",
    "da": "static-7.1162",
    "de": "static-7.1162",
    "el": "static-7.1162",
    "en-gb": "static-7.1162",
    "en": "static-7.1162",
    "es-mx": "static-7.1162",
    "es": "static-7.1162",
    "et": "static-7.1162",
    "fi": "static-7.1162",
    "fr-ca": "static-7.1162",
    "fr": "static-7.1162",
    "he-il": "static-7.1162",
    "hi": "static-7.1162",
    "hr": "static-7.1162",
    "hu": "static-7.1162",
    "id": "static-7.1162",
    "it": "static-7.1162",
    "ja": "static-7.1162",
    "ko": "static-7.1162",
    "lt": "static-7.1162",
    "ms": "static-7.1162",
    "nl": "static-7.1162",
    "no": "static-7.1162",
    "pl": "static-7.1162",
    "pt-br": "static-7.1162",
    "pt-pt": "static-7.1162",
    "ro": "static-7.1162",
    "ru": "static-7.1162",
    "sk": "static-7.1162",
    "sl": "static-7.1162",
    "sv": "static-7.1162",
    "th": "static-7.1162",
    "tl": "static-7.1162",
    "tr": "static-7.1162",
    "uk": "static-7.1162",
    "vi": "static-7.1162",
    "x-pseudo": "static-7.1162",
    "zh-cn": "static-7.1162",
    "zh-hk": "static-7.1162",
    "zh-tw": "static-7.1162"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ru', {version: 'static-7.1162'}); }
})();


